"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotedTag = exports.OfferTitle = exports.OfferTitleInput = exports.AnalyticsDataCell = exports.ApplicantsCell = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
exports.ApplicantsCell = (0, styled_components_1.default)(elements_1.Link) `
	&& {
		display: flex;
		margin: -16px;
		padding: 18px 16px;
		justify-content: center;
		transition: 0.3s;
		color: inherit;

		&:hover {
			background: #f7eae4;
		}
	}
`;
exports.AnalyticsDataCell = styled_components_1.default.span `
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.25rem;

	svg {
		margin-right: 0.5rem;
	}
`;
exports.OfferTitleInput = styled_components_1.default.input `
	padding: 0.5rem 0.25rem;
	background-color: $colorWhite;
	outline: none;
	border: 1px solid transparent;
	width: 100%;
	height: 100%;
	border-radius: 4px;

	&:hover {
		border: 1px solid ${props => props.theme.color.gray2};
	}
	&:focus {
		border: 1px solid ${props => props.theme.color.gray3};
	}
`;
exports.OfferTitle = styled_components_1.default.div `
	padding: 0.5rem 0.25rem;
	span {
		font-size: 0.875rem;
		color: ${props => props.theme.color.gray5};
	}
`;
exports.PromotedTag = (0, styled_components_1.default)(elements_1.Tag) `
	height: fit-content;
	margin-left: 1rem;
	display: flex;
	align-items: center;
`;
